<template>
    <div class="tabs-wrapper section-space--pt_120 section-space--pb_120" :class="BgGradient">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="section-title text-center section-space--mb_60">
                        <h2 class="font-weight--bold mb-15 wow move-up">'Solving it later' costs $1.56 trillion a year</h2>
   
                        <h6 class="sub-heading">According to the Consortium for
                        Information and Software Quality
                                                <a  target="_blank" href="https://www.it-cisq.org/press-releases/cost-of-poor-software-quality-in-the-us/" class="hover-style-link hover-style-link--green">report:</a>
                                            </h6>
                    </div>
                </div>
            </div>
            <div class="row start-ups-left-tab">
                <div class="col-lg-4 order-2 order-lg-1">
                    <slick class="slick1 tab-slider-nav" :options="slickOptions">
                        <div class="tab-slider-nav--list wow move-up">
                            <i class="ht-slider-tab-icon fal fa-dollar-sign"></i>
                            <h6>Exposing end-users to slow, buggy software costed US companies $2.08
                            trillion in 2020.</h6>
                        </div>
                        <div class="tab-slider-nav--list wow move-up">
                            <i class="ht-slider-tab-icon fal fa-fire-extinguisher"></i>
                            <h6>Of the $2.08 trillion, 75% were related to operational failures, including performance.</h6>
                        </div>
                        <div class="tab-slider-nav--list wow move-up">
                            <i class="ht-slider-tab-icon fal fa-rocket"></i>
                            <h6>If discovered in production it costs 100x more. The sooner the better.</h6>
                            
                        </div>
                    </slick>
                </div>
                <div class="col-lg-8 order-1 order-lg-2">
                    <slick class="slick2" :options="slickOptions2">
                        <div class="pro-large-img img-zoom wow move-up">
                            <img class="img-fluid" src="../assets/img/banners/loosing-money.png" alt="loosing-money" />
                        </div>
                        <div class="pro-large-img img-zoom wow move-up">
                            <img class="img-fluid" src="../assets/img/banners/production-issues.png" alt="production-issues" />
                        </div>
                        <div class="pro-large-img img-zoom wow move-up">
                            <img class="img-fluid" src="../assets/img/banners/save-money.png" alt="save-money" />
                        </div>
                    </slick>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Slick from 'vue-slick';

    export default {
        name: 'TabTwo',
        props: ["BgGradient"],
        components: {
            Slick
        },
        data() {
            return {
                slickOptions: {
                    slidesToShow: 3,
                    focusOnSelect: true,
                    vertical: true,
                    asNavFor: '.slick2'
                },
                slickOptions2: {
                    arrows: false,
                    fade:true,
                    dots:true,
                    asNavFor: '.slick1'
                }
            };
        }
    };
</script>